'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var wrapValidator = {};

exports.__exports = wrapValidator;
